module.exports = __webpack_public_path__ + "img/title.9b186ae9.png";